import { MentorProfileWizard } from "@/components/mentor-profile/wizard-shell";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_mentor_profile/mentor-profile/")({
  component: MentorProfilePage,
});

function MentorProfilePage() {
  // Do not gate this route on the PostHog flag. Freshly activated mentors are
  // navigated here from accept-invite before flags resolve for their new
  // distinct_id; bouncing to `/` drops them on the full dashboard.
  // Flag gating stays on send-invite + useMentorOnboardingGate.
  return <MentorProfileWizard />;
}
